import { useMemo } from 'react';
import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';

export type OrgStatus = { isActive: boolean; isSuspended: boolean };

/**
 * Maps Clerk org IDs to the corresponding Convex organization's status
 * ({ isActive, isSuspended }). Returns an empty object while loading or when no
 * IDs are provided.
 *
 * `undefined` for an ID means "still loading"; a present value is authoritative.
 */
export default function useOrgActiveStatus(
  clerkOrgIds: string[],
): Record<string, OrgStatus> {
  const stableIds = useMemo(() => {
    const sorted = [...clerkOrgIds].sort();
    return sorted;
  }, [clerkOrgIds.join('|')]);

  const result = useQuery(
    api.organizations.getOrgActiveStatusByClerkIds,
    stableIds.length > 0 ? { clerkOrgIds: stableIds } : 'skip',
  );

  return result ?? {};
}
